
export const HorizontalSidebarData = [
    {
        title: 'Main',
        showAsTab: false,
        separateRoute: false,
        menu: [
          {
            menuValue: 'Batches',
            hasSubRoute: false,
            showSubRoute: false,
            icon: 'book',
            base: 'batches',
            route: '/index',
          },
          {
            menuValue: 'My Account',
            hasSubRoute: false,
            showSubRoute: false,
            icon: 'user',
            base: 'account',
            route: '/account',
          },
          {
            menuValue: 'Support',
            hasSubRoute: false,
            showSubRoute: false,
            icon: 'help',
            base: 'support',
            route: '/support',
          },
        ],
      },
];